import { Box, Typography, useTheme } from "@mui/material"
import { Carousel, CarouselItem } from "components/Carousel"
import { useTranslation } from "providers/i18n"
import { useNavigate } from "react-router-dom"
import { useCallback } from "react"
import { useSeeAndDo } from "extensions/one-siam/hooks"
import { LeftToRightWrapper } from "components/LeftToRightWrapper"

export const MobileSeeAndDoButton = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { hasData, sortedPostByDefaultVenue } = useSeeAndDo()
  const theme = useTheme()
  const { root, carousel, carouselItem, image, labelText } =
    theme.components?.[`SeeAndDoButton`].styleOverrides || {}
  const { carouselOptions = {} } =
    theme.components?.[`SeeAndDoButton`].defaultProps || {}

  const handleClick = useCallback(() => {
    navigate("/see-and-do")
  }, [navigate])

  return (
    <LeftToRightWrapper>
      {hasData && (
        <Box sx={root} onClick={handleClick}>
          <Carousel
            options={{
              type: "fade",
              rewind: true,
              autoplay: true,
              pagination: false,
              interval: 3000,
              arrows: false,
              speed: 1500,
              padding: 4,
              ...carouselOptions,
            }}
            sx={carousel}
          >
            {sortedPostByDefaultVenue.map((post) => {
              return (
                <CarouselItem key={post.id} sx={carouselItem}>
                  <Box
                    sx={image}
                    component="img"
                    src={post?.properties?.feature_image}
                  />
                </CarouselItem>
              )
            })}
          </Carousel>
          <Typography sx={labelText}>{t("See & Do")}</Typography>
        </Box>
      )}
    </LeftToRightWrapper>
  )
}
